module.exports = __webpack_public_path__ + "Flag-528.f4efe8fbf6f8016b10713842ae56555e.svg";